import React from "react";
import { Outlet } from "react-router-dom";
import NavigationBar from "./NavigationBar";
import { Container } from "@mui/material";
import ShareStockFooter from "../ShareStockFooter/ShareStockFooter";

const WithNavigationBar: React.FC = () => {
  return (
    <div>
      <NavigationBar />
      <Container maxWidth={false} sx={{ backgroundColor: "#F8E3F5", minHeight: '100vh', pt: 3, mt: 8 }}>
        <Outlet />
        <ShareStockFooter />
      </Container>
    </div>
  );
};

export default WithNavigationBar;
